import { t } from "i18next";
import { Accordion } from "react-bootstrap";
import { BsInfoCircle } from "react-icons/bs";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { debugLogPages } from "../../app/helpers/debugHelper";
import CheckListOptionsCatalogState from "./CheckListOptionsCatalogState";
import CheckListOptionsCatalogStateMulti from "./CheckListOptionsCatalogStateMulti";
import EndUserRemoveFilterOptionsL3 from "./EndUserRemoveFilterOptionsL3";

const FILTER_SERIES = "catalogserie_id";

const FILTER_PROBLEMS = "catalogproblem_ids"

const FILTER_CIIUS = "catalogciiu_levels";

const FILTER_CONTINENTS = "catalogcontinents_id";
const FILTER_REGIONS = "catalogregions_id"
const FILTER_COUNTRIES = "catalogcountries_id";

const INDICATORS_TITLE = "indicators_title";
const INDICATORS_TITLE_INFO = "indicators_title_info";

const L3FilterRegulation = ({
  searchTextState,
  catalogsToFilter,
  setCatalogsToFilter,
  itemsPerPage,
  setItemsPerPage,
  moduleSelected,
  setModuleSelected,
  catalogCiiuLevel1Selected,
  setCatalogCiiuLevel1Selected,
  indicatorsToFilter,
  setIndicatorsToFilter
}) => {

  debugLogPages(':: L3FilterRegulation');

  const {
    listSeriesFilter,
    listProblemsFilter,

  } = useSelector((state) => state.catalog);

  const {
    listCiiusFilter
  } = useSelector((state) => state.catalogCiiu);

  return (
    <div>

      <EndUserRemoveFilterOptionsL3
        searchTextState={searchTextState}
        catalogsToFilter={catalogsToFilter}
        setCatalogsToFilter={setCatalogsToFilter}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        moduleSelected={moduleSelected}
        setModuleSelected={setModuleSelected}
        catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
        setCatalogCiiuLevel1Selected={setCatalogCiiuLevel1Selected}
        indicatorsToFilter={indicatorsToFilter}
        setIndicatorsToFilter={setIndicatorsToFilter} />

      {/*Titulo*/}
      <div style={{ fontWeight: '600', paddingTop: '1em', borderBottom: 'red 0.2em solid', fontSize: '1.4rem' }}>
        <span>{t(
          `${moduleSelected &&
          moduleSelected.key &&
          moduleSelected.key
          }.search.filters`
        )}</span>
      </div>

      <div>
        <div className="accordionFilter">
          <Accordion defaultActiveKey="2" flush alwaysOpen>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_SERIES}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_SERIES}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogState
                  dataList={listSeriesFilter}
                  title="Series"
                  keyCatalog={`${FILTER_SERIES}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="9">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_PROBLEMS}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_PROBLEMS}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogState
                  dataList={listProblemsFilter}
                  title="Problemas"

                  keyCatalog={`${FILTER_PROBLEMS}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="10">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_CIIUS}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_CIIUS}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogStateMulti
                  dataList={listCiiusFilter}
                  title="Ciiu"

                  keyCatalog={`${FILTER_CIIUS}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            {/*<Accordion.Item eventKey="13">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_CONTINENTS}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_CONTINENTS}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogStateLocat
                  dataList={listContinentsFilter}
                  title="Continentes"

                  keyCatalog={`${FILTER_CONTINENTS}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="14">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_REGIONS}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_REGIONS}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogStateLocat
                  dataList={listRegionsFilter}
                  title="Regiones"

                  keyCatalog={`${FILTER_REGIONS}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="15">
              <Accordion.Header>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="tit-view viewContentTitIndicator">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_COUNTRIES}`)}</span>
                  <BsInfoCircle style={{ marginLeft: "5px" }} data-tip data-for={`${FILTER_COUNTRIES}_tip`} />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <CheckListOptionsCatalogStateLocat
                  dataList={listCountriesFilter}
                  title="Paises"

                  keyCatalog={`${FILTER_COUNTRIES}`}
                  searchTextState={searchTextState}
                  catalogsToFilter={catalogsToFilter}
                  setCatalogsToFilter={setCatalogsToFilter}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  moduleSelected={moduleSelected}
                    catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
                  indicatorsToFilter={indicatorsToFilter}
                  setIndicatorsToFilter={setIndicatorsToFilter}
                />
              </Accordion.Body>
            </Accordion.Item>*/}

          </Accordion>

          <ReactTooltip id={`${FILTER_SERIES}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_SERIES}`
            )}
          </ReactTooltip>

          <ReactTooltip id={`${FILTER_PROBLEMS}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_PROBLEMS}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_CIIUS}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_CIIUS}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_CONTINENTS}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_CONTINENTS}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_REGIONS}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_REGIONS}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${FILTER_COUNTRIES}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.short.${FILTER_COUNTRIES}`
            )}
          </ReactTooltip>
          <ReactTooltip id={`${INDICATORS_TITLE}_tip`} place="left" effect="solid">
            {t(
              `${moduleSelected &&
              moduleSelected.key &&
              moduleSelected.key
              }.search.${INDICATORS_TITLE_INFO}`
            )}
          </ReactTooltip>

        </div>
      </div>
    </div>
  );
};

export default L3FilterRegulation;